import React from "react";
import { useAppState } from "../../StateStore/Store";

import {
  Card,
  CardContent,
  CardHeader,
  List,
  Inline,
  Checkbox,
  FormGroup,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@digitalreality/ui";
import { useForm } from "react-hook-form";
import { AppTypes } from "../../Helpers/Constants";
import { CheckboxCheckedIcon, CloseFilledIcon, LockIcon, SettingsIcon } from "@digitalreality/ui-icons";
import { t } from "i18next";
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';

/*
Snow data
 - button to link to project

Button to send an email to setup an interface
*/

export default function DataReceivers({ onSubmit, formRef }: any) {
  const { state } = useAppState();

  const { handleSubmit } = useForm({
    mode: "onBlur",
    defaultValues: state.projectModal.project,
  });

  const addDataReceiver = (isactive: boolean, type: string, name: string, needsLicense: boolean) => {
    return (
        <List>
            <ListItem sx={{ padding: '0'}}>
                <ListItemIcon sx={{ minWidth: '36px'}}>
                    {needsLicense ? <LockIcon color="disabled" /> : 
                    isactive ? 
                        <CheckboxCheckedIcon color="disabled" /> : 
                        <CloseFilledIcon color="disabled" />}
                </ListItemIcon>
            <ListItemText>{name}</ListItemText>
        </ListItem>
        {needsLicense ?
            <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Interface license missing</Typography>}/></ListItem> :
            <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>Available</Typography>}/></ListItem>
        }
        <Divider />
    </List>
    );
  };

  
  return (
    <form
        id="interfaceForm"
        onSubmit={handleSubmit(onSubmit)}
        ref={formRef}
        autoComplete="off">
        <FormGroup>
            <Inline sx={{ width: "1292px", overflow: 'auto'}} gap={2}>
                <Card sx={{ height: "538px", width: "400px", p: 0}}>
                    <CardHeader title="API Connections"/>
                    <Divider />
                    <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                        {state.projectModal.dataconnections?.datareceivers?.map((app) => { return addDataReceiver(app.isactive, app.type, app.name, app.needsinterfacelicense) })}
                    </CardContent>
                </Card>
                <Card sx={{ height: "538px", width: "900px", p: 0}}>
                    <CardHeader title="API Details"/>
                    <Divider />
                    <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                        <List>
                            <ListItem sx={{ padding: '0'}}>
                                <ListItemIcon sx={{ minWidth: '36px'}}>
                                    <SettingsIcon color="disabled" />
                                </ListItemIcon>
                                <ListItemText>Rest Token</ListItemText>
                            </ListItem>
                            <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>{state.projectModal.dataconnections?.projectinterfacetoken}</Typography>}/></ListItem>
                            <Divider />
                        </List>
                        <List>
                            <ListItem sx={{ padding: '0'}}>
                                <ListItemIcon sx={{ minWidth: '36px'}}>
                                    <SettingsIcon color="disabled" />
                                </ListItemIcon>
                                <ListItemText>API URL</ListItemText>
                            </ListItem>
                            <ListItem sx={{ padding: '0'}}><ListItemText sx={{ width: "350px" }} primary={<Typography style={{ fontSize: '12px', color: "#888888" }}>{state.projectModal.dataconnections?.projectapiurl}</Typography>}/></ListItem>
                            <Divider />
                        </List>
                    </CardContent>
                </Card>
            </Inline>
            <Typography sx={{ mt: '18px', mb: '0' }} style={{ fontSize: '12px', color: "#888888" }}>If you need further assistance setting up a connection or activating a license, please contact <a href="mailto:lmc.support@leica-geosystems.com" style={{ color: "#ffffff", textDecoration: 'none', marginLeft: '5px' }}>lmc.support@leica-geosystems.com</a></Typography>
        </FormGroup>
    </form>
);
}
